import { Typography } from '@mui/material'
import { FlexBox } from 'components/atoms'
import { useBetContext } from 'contexts/BetContext'

export const FormulaKeyButton = ({
    title,
    selected,
    onClick
}: {
    title: string
    selected: boolean
    onClick: () => void
}) => {
    const { mainColor } = useBetContext()

    return (
        <FlexBox
            onClick={() => onClick && onClick()}
            sx={{
                width: '100%',
                height: 50,
                borderRadius: 1,
                backgroundColor: selected ? mainColor : 'white',
                border: `1px solid ${mainColor}`,
                justifyContent: 'center',
                cursor: 'pointer'
            }}
        >
            <Typography
                variant="title-14-bold"
                sx={{
                    color: selected ? 'white' : mainColor,
                    textAlign: 'center',
                    padding: 1,
                    whiteSpace: 'pre-wrap'
                }}
            >
                {title}
            </Typography>
        </FlexBox>
    )
}
